(() => {
  let observer;
  function initialize() {
    if (observer) observer.disconnect();
    const header = document.querySelector('.header-container');
    if (!header) return;
    const update = () => document.documentElement.style.setProperty('--store-header-offset',
      (getComputedStyle(header).position === 'fixed' ? Math.ceil(header.getBoundingClientRect().height) : 0) + 'px');
    observer = new ResizeObserver(update);
    observer.observe(header);
    update();
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
